export default "__VITE_ASSET__D3Xo32nl__"